import { spacing } from '@scaleaq/sui-tokens/responsive';
import { styled } from 'styled-components';

export const GroupBorder = styled.div`
  border: 1px solid var(--sui-stroke-neutral-50);
  width: 100%;
  padding: ${spacing['2xlarge']};
  border-radius: 0.3125rem;
`;
